var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.0311 3.08326C0.430404 1.88187 1.30402 0.468323 2.64722 0.468323H7.64131C8.98451 0.468323 9.85813 1.88187 9.25743 3.08326L6.76039 8.07735C6.09451 9.40911 4.19403 9.40911 3.52815 8.07735L1.0311 3.08326Z",
    fill: "#F46463",
    stroke: "white",
    strokeWidth: 0.903439
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.cff3e3d6200aaa1ed54f2d42a4829400.svg";
export { ForwardRef as ReactComponent };